import ContentfulEntry from "./ContentfulEntry";
import { get } from 'lodash'

class ContentfulImage {
    static default = {
        title: '',
        description: '',
        file: {}
    }

    static id = (contentfulImage) => ContentfulEntry.id(contentfulImage)

    static title = (contentfulImage) => {
        const fields = ContentfulEntry.fields(contentfulImage);
		const title = get(fields, "title", ContentfulImage.default.title);
		return title;
    }

    static description = (contentfulImage) => {
        const fields = ContentfulEntry.fields(contentfulImage);
        const description = get(fields, "description", ContentfulImage.default.description);
        return description
    }

    static file = (contentfulImage) => {
        const fields = ContentfulEntry.fields(contentfulImage);
        const file = get(fields, 'file', ContentfulImage.default.file);
        return file
    }
}

export default ContentfulImage